/**
 * @generated SignedSource<<24090ad767f87dac9f1ca295f7515397>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type blankApiIntegrationSalesChannelDialogCurrenciesQuery$variables = Record<PropertyKey, never>;
export type blankApiIntegrationSalesChannelDialogCurrenciesQuery$data = {
  readonly currencies: ReadonlyArray<{
    readonly code: string | null;
    readonly id: string;
    readonly name: string | null;
    readonly symbol: string | null;
  } | null> | null;
  readonly lcidCurrenciesList: ReadonlyArray<{
    readonly languageCulture: string | null;
  } | null> | null;
};
export type blankApiIntegrationSalesChannelDialogCurrenciesQuery = {
  response: blankApiIntegrationSalesChannelDialogCurrenciesQuery$data;
  variables: blankApiIntegrationSalesChannelDialogCurrenciesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Currency",
    "kind": "LinkedField",
    "name": "currencies",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "symbol",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "LanguageCurrency",
    "kind": "LinkedField",
    "name": "lcidCurrenciesList",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "languageCulture",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "blankApiIntegrationSalesChannelDialogCurrenciesQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "blankApiIntegrationSalesChannelDialogCurrenciesQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "2f12589723d091945277f5d556c4a0f2",
    "id": null,
    "metadata": {},
    "name": "blankApiIntegrationSalesChannelDialogCurrenciesQuery",
    "operationKind": "query",
    "text": "query blankApiIntegrationSalesChannelDialogCurrenciesQuery {\n  currencies {\n    id\n    code\n    name\n    symbol\n  }\n  lcidCurrenciesList {\n    languageCulture\n  }\n}\n"
  }
};
})();

(node as any).hash = "28b9a49f3b7ad04350a2c93b5c19c6c9";

export default node;
